import styled from 'styled-components'

export const LHeader = styled.div<{ $inverted?: boolean }>`
  border: none;
  background: ${({ $inverted }) => $inverted ? "unset" : "linear-gradient(27deg, rgba(60, 123, 53, 1) 8.33%, rgba(73, 150, 64, 1) 91.67%)"};
  width: 100%;
  height: 50px;
  position: fixed;
  top: 0px;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`

export const LFooterLink = styled.a<{ $inverted?: boolean }>`
  font-family: "Roboto-Bold";
  font-size: 16px;
  line-height: 24px;
  color: ${({ $inverted }) => $inverted ? 'white' : '#3C7B35'};
  text-decoration: none;
  margin-right: 16px;

  &:hover {
    opacity: 0.8;
  }
`;

export const Header = styled.div`
  border: none;
  background-color: #003b5c;
  width: 100%;
  height: 50px;
  position: fixed;
  top: 0px;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;

  &.in-app {
    display: none;
  }
`

export const HeaderInfo = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  color: #fff;
  font-size: 10px;
  text-align: right;
  font-family: "Bold";
  text-transform: uppercase;
  letter-spacing: 1px;

  .info-value {
    font-size: 14px;
    margin-top: 4px;
  }
`